export default __webpack_public_path__ + "assets/models/f07758c3f526f216b8b893cc7d8b2b68.glb";